import { useCallback, useEffect, useRef, useState } from 'react'

import ReactSectionHeader from '../../ReactSectionHeader'
import ReactProductTeaser from '../ReactProductTeaser'
import ReactTeaserCard from '../ReactTeaserCard'
import { Elements, ReactMultiProductTeaserProps, TeaserType } from '../types'
import './ReactMultiProductTeaser.scss'

const ReactMultiProductTeaser = (props: ReactMultiProductTeaserProps): JSX.Element => {
  const {
    cardType,
    eyebrow,
    title,
    description,
    ruleExpression = '',
    contentFragments,
    contentType,
    condition,
    ruleType,
    tokenProperties,
    priceTagIcon,
    isInEditor = false
  } = props
  const hasThreeCards = cardType === TeaserType.exposedthreeup
  const hasTwoCards = cardType === TeaserType.exposedtwoup
  const hasOneCard = cardType === TeaserType.exposedoneup
  const cardsLength = hasTwoCards ? 2 : hasThreeCards ? 3 : hasOneCard ? 1 : 0
  const newContentFragments = contentFragments.length > 0 ? contentFragments.slice(0, cardsLength) : []

  // const getElement = (elements: Elements, key: keyof Elements) => {
  //   const element = elements[key]
  //   return element
  // }

  const [priceHeight, setPriceHeight] = useState(0)
  const priceRef = useRef([])
  useEffect(() => {
    setTimeout(() => {
      const priceHeights = priceRef?.current?.map((ref: any) => ref?.offsetHeight)
      const maxPriceHeight = Math.max(...priceHeights)
      setPriceHeight(maxPriceHeight)
    }, 2000)
  }, [])

  const renderCard = useCallback(
    (elements: Elements, index: number, id: string) => {
      return (
        <div
          className={`col-md-12 ${hasThreeCards ? 'col-lg-4' : 'col-lg-6'} cards-container`}
          key={`react-multi-product-teaser-${index}}`}
          data-testid='react-multi-product-teaser-card'
        >
          <ReactProductTeaser
            id={id}
            ruleExpression={ruleExpression}
            index={index}
            cardType={cardType}
            tokenProperties={tokenProperties}
            priceTagIcon={priceTagIcon}
            elements={elements}
            contentType={contentType}
            // elements={{
            //   image: getElement(elements, 'image') as ElementObject,
            //   altImage: getElement(elements, 'altImage') as ElementObject,
            //   contentBadgeColor: getElement(elements, 'contentBadgeColor') as ElementObject,
            //   contentBadgeText: getElement(elements, 'contentBadgeText') as ElementObject,
            //   eyebrowIcon: getElement(elements, 'eyebrowIcon') as ElementObject,
            //   eyebrow: getElement(elements, 'eyebrow') as ElementObject,
            //   heading: getElement(elements, 'heading') as ElementObject,
            //   additionalNote: getElement(elements, 'additionalNote') as ElementObject,
            //   description: getElement(elements, 'description') as ElementObject,
            //   bulletIcon: getElement(elements, 'bulletIcon') as ElementObject,
            //   bulletPoints: getElement(elements, 'bulletPoints') as ElementArrayObject,
            //   planName: getElement(elements, 'planName') as ElementObject,
            //   price: getElement(elements, 'price') as ElementObject,
            //   scratchPrice: getElement(elements, 'scratchPrice') as ElementObject,
            //   term: getElement(elements, 'term') as ElementObject,
            //   discount: getElement(elements, 'discount') as ElementObject,
            //   buttonTextPrimary: getElement(elements, 'buttonTextPrimary') as ElementObject,
            //   buttonLinkPrimary: getElement(elements, 'buttonLinkPrimary') as ElementObject,
            //   buttonLinkTypePrimary: getElement(elements, 'buttonLinkTypePrimary') as ElementObject,
            //   buttonLinkNewTabPrimary: getElement(elements, 'buttonLinkNewTabPrimary') as ElementBooleanObject,
            //   buttonTextSecondary: getElement(elements, 'buttonTextSecondary') as ElementObject,
            //   buttonLinkSecondary: getElement(elements, 'buttonLinkSecondary') as ElementObject,
            //   buttonLinkNewTabSecondary: getElement(elements, 'buttonLinkNewTabSecondary') as ElementBooleanObject,
            //   buttonLinkTypeSecondary: getElement(elements, 'buttonLinkTypeSecondary') as ElementObject
            // }}
            priceHeight={priceHeight}
            priceRef={priceRef}
          />
        </div>
      )
    },
    [newContentFragments]
  )

  return (
    <div data-testid='react-multi-product-teaser-container' className='react-multi-product-teaser-container'>
      <ReactSectionHeader
        eyebrow={{
          value: eyebrow,
          isRTE: true
        }}
        title={{
          value: title,
          isRTE: true
        }}
        description={{
          className: 'main-description',
          value: description,
          isRTE: true
        }}
        isInEditor={isInEditor}
      />

      <div
        data-testid='react-multi-product-teaser-cards-container'
        className='react-multi-product-teaser-cards-container overflow-hidden'
      >
        <div className='row cards-row'>
          <ReactTeaserCard
            contentFragments={newContentFragments}
            ruleExpression={ruleExpression}
            ruleType={ruleType}
            condition={condition}
            contentType={contentType}
            renderCard={renderCard}
          />
        </div>
      </div>
    </div>
  )
}
export default ReactMultiProductTeaser
